/**
 * Normalize any Date to UTC midnight (00:00:00.000Z) of its UTC calendar day.
 *
 * This strips the time component while preserving the UTC date. Useful for ensuring
 * consistent date comparisons when dates may have been created with different time-of-day
 * values (e.g., mixing UTC midnight dates from `toUTCDateMidnight` with local midnight
 * dates from `utcToLocal`).
 *
 * @example
 * // UTC midnight date (from toUTCDateMidnight)
 * normalizeToUTCMidnight(new Date('2026-02-16T00:00:00Z')) // => 2026-02-16T00:00:00Z
 *
 * // Local midnight date (from utcToLocal, e.g., in PST)
 * normalizeToUTCMidnight(new Date('2026-02-16T08:00:00Z')) // => 2026-02-16T00:00:00Z
 */
export const normalizeToUTCMidnight = (date: Date): Date =>
  new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()))
